module.exports = __webpack_public_path__ + "static/assets/f36a78bf7df375626e7ae034f782d696.png";